import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

class IndexView extends Component {

    createBloc = new CreateBloc();
    indexBloc = new IndexBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            positionOption: [],
            positionBknOption: [],
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            positionBknFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'position_bkn_id',
                    order: 'asc' 
                }
            }
        }
    }

    loadPosition = async () => {
        let offset = (this.state.positionFilter.page_number-1)*this.state.positionFilter.page_size
        const query = {
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1
        }
        await this.createBloc.fetchPosition(query)
    }

    loadPositionBkn = async () => {
        let offset = (this.state.positionBknFilter.page_number-1)*this.state.positionBknFilter.page_size
        const query = {
            search: this.state.positionBknFilter.filter_value,
            limit: this.state.positionBknFilter.page_size,
            offset: offset,
            order: this.state.positionBknFilter.sort_order.column,
            sort: this.state.positionBknFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchPositionBkn(query);
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.positionFilter.filter_value = value

        this.timer = setTimeout(() => this.loadPosition(), 800);
    }

    handleSelectBknInputChange = value => {
        clearTimeout(this.timer)

        this.state.positionBknFilter.filter_value = value

        this.timer = setTimeout(() => this.loadPosition(), 800);
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.loadPosition()
        this.loadPositionBkn()

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       

        this.createBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.positionBknChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionBknOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default: 
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.positionChannel?.unsubscribe()
        this.indexBloc.positionBknChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`/master/mapping-jabatan-bkn.html`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Tambah Mapping Jabatan Bkn</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="rank_name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <Select
                                                    name="position_mapping_bkn_position_uuid"
                                                    placeholder="Pilih Jabatan..."
                                                    errorMessage="Pilih Jabatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.positionOption}
                                                    optionLabel="position_name"
                                                    optionValue="position_uuid"
                                                    onInputChange={(e) => this.handleSelectInputChange(e)}
                                                />
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <label
                                                htmlFor="rank_name"
                                                className="col-md-3 col-form-label"
                                            >
                                            E-Formasi<span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <Select
                                                    name="position_mapping_bkn_position_bkn_uuid"
                                                    placeholder="E-Formasi..."
                                                    errorMessage="Pilih Jabatan Bkn"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.positionBknOption}
                                                    optionLabel="position_bkn_name"
                                                    optionValue="position_bkn_uuid"
                                                    onInputChange={(e) => this.handleSelectBknInputChange(e)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="rank_group_code"
                                                className="col-md-3 col-form-label"
                                            >
                                            Analisis Beban Kerja <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="position_mapping_bkn_quota"
                                                    placeholder="Analisis Beban Kerja..."
                                                    type="number"
                                                    errorMessage="Masukkan Analisis Beban Kerja"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="rank_group_code"
                                                />
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/mapping-jabatan-bkn.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView